import { MagicTokenModel } from "./MagicToken.model";

export class MagicToken extends MagicTokenModel {
    // Add custom methods here
}
